import styled from "styled-components";

export const RightBlockContainer = styled("section")`
  position: relative;
  width: 100%;
  background-image: url("/img/meals-banner.png");
  min-height: 615px;
  background-size: contain;
  background-repeat: no-repeat;

  
  @media only screen and (max-width: 1024px) {
    padding: 8rem 0 6rem;
  }

  @media only screen and (max-width: 768px) {
    padding: 1rem 0 3rem;
    background-size: contain;

  }
`;

export const Content = styled("p")`
  margin: 1.5rem 0 2rem 0;
`;

export const ContentWrapper = styled("div")`
  position: relative;
  max-width: 610px;

  @media only screen and (max-width: 575px) {
    padding-bottom: 4rem;
  }
`;

export const ContentWrapperRight = styled("div")`
  position: relative;
  max-width: 405px;
  background-repeat: no-repeat;
  width: 100%;
  min-height: 503px;
  background-size: contain;

  @media only screen and (max-width: 575px) {
    padding-bottom: 4rem;
  }
`;


export const ButtonWrapper = styled("div")`
  display: flex;
  justify-content: center;
  max-width: 100%;

  @media screen and (min-width: 1024px) {
    max-width: 80%;
  }

  button:last-child {
    margin-left: 20px;
  }
`;